export default __webpack_public_path__ + "static/media/2_Intro.f841d571.mp4";